import { render, staticRenderFns } from "./serverCount.vue?vue&type=template&id=34d2f3a6&"
import script from "./serverCount.vue?vue&type=script&lang=js&"
export * from "./serverCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d2f3a6')) {
      api.createRecord('34d2f3a6', component.options)
    } else {
      api.reload('34d2f3a6', component.options)
    }
    module.hot.accept("./serverCount.vue?vue&type=template&id=34d2f3a6&", function () {
      api.rerender('34d2f3a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/serverCount.vue"
export default component.exports